/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { PureComponent } from 'react'

const Color = css`
  width: inherit;
  height: auto;
  .clip {
    fill: transparent !important;
  }
`

export default class PickIco extends PureComponent {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="15.277" height="14.595" viewBox="0 0 15.277 14.595" css={Color} className="pick-ico">
        <g id="그룹_33876" data-name="그룹 33876" transform="translate(0.501 0.501)">
          <g id="그룹_33862" data-name="그룹 33862" transform="translate(-0.001 -0.001)">
            <path id="합치기_782" data-name="합치기 782"
                  d="M6.813,12.634l.028-.661,3.851-3.839.1-.105,1.516,1.516L10.6,11.255v.01L9.32,12.547l-.017.01-.944.932-1.585.079Zm-4.869,0A1.943,1.943,0,0,1,0,10.692V1.945A1.938,1.938,0,0,1,1.944,0h6.8a1.945,1.945,0,0,1,1.945,1.945V6.074l-.409.41L5.7,11.071a.96.96,0,0,0-.3.668l-.04.895Zm.368-4.995a.722.722,0,0,0,.729.729h4.6a.729.729,0,0,0,0-1.458h-4.6A.728.728,0,0,0,2.312,7.639Zm0-3.508a.722.722,0,0,0,.729.729h4.6a.729.729,0,0,0,0-1.458h-4.6A.729.729,0,0,0,2.312,4.131ZM11.829,7l.786-.787a.335.335,0,0,1,.467,0l1.05,1.05a.334.334,0,0,1,0,.466l-.787.787Z"
                  fill="#ecf2ff" stroke="rgba(0,0,0,0)" strokeMiterlimit="10" strokeWidth="1"/>
            <path id="패스_43670" data-name="패스 43670"
                  d="M7.706,8.568h-4.6a.729.729,0,1,1,0-1.458h4.6a.729.729,0,1,1,0,1.458"
                  transform="translate(-0.066 -0.199)" fill="#ecf2ff" className="clip"/>
            <path id="패스_43671" data-name="패스 43671"
                  d="M2.38,4.229A.728.728,0,0,1,3.109,3.5h4.6a.729.729,0,0,1,0,1.458h-4.6a.722.722,0,0,1-.729-.729"
                  transform="translate(-0.066 -0.097)" fill="#ecf2ff" className="clip"/>
            <path id="패스_43672" data-name="패스 43672"
                  d="M8.434,4.229a.722.722,0,0,1-.729.729h-4.6a.729.729,0,1,1,0-1.458h4.6a.728.728,0,0,1,.729.729"
                  transform="translate(-0.066 -0.097)" fill="#1b1f2a" className="clip"/>
            <path id="패스_43673" data-name="패스 43673"
                  d="M8.434,7.839a.722.722,0,0,1-.729.729h-4.6a.729.729,0,1,1,0-1.458h4.6a.728.728,0,0,1,.729.729"
                  transform="translate(-0.066 -0.199)" fill="#1b1f2a" className="clip"/>
          </g>
        </g>
      </svg>
    )
  }
}

